import { creditHealthUrl } from "./endpoints.js";
const creditHealthCacheKey = ({
  accountId,
  accountIdType,
  lang
}) => [creditHealthUrl, { accountId, accountIdType, lang }];
export {
  creditHealthCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
